/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Support {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Create a new support case.
   *
   * @tags Support
   * @name CreateCase
   * @summary Create Case
   * @request POST:/api/support/cases
   * @secure
   */
  createCase = (data, params = {}) =>
    this.http.request({
      path: `/api/support/cases`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List support cases with multi-facet filters and pagination.
   *
   * @tags Support
   * @name ListCases
   * @summary List Cases
   * @request GET:/api/support/cases
   * @secure
   */
  listCases = (query, params = {}) =>
    this.http.request({
      path: `/api/support/cases`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get operational support metrics for management dashboard (open, urgent, SLA breached, avg response time).
   *
   * @tags Support
   * @name GetCaseMetrics
   * @summary Get Case Metrics
   * @request GET:/api/support/cases/metrics
   * @secure
   */
  getCaseMetrics = (params = {}) =>
    this.http.request({
      path: `/api/support/cases/metrics`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get case details including threaded messages (internal notes filtered for non-staff).
   *
   * @tags Support
   * @name GetCase
   * @summary Get Case
   * @request GET:/api/support/cases/{case_id}
   * @secure
   */
  getCase = (caseId, params = {}) =>
    this.http.request({
      path: `/api/support/cases/${caseId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update case status, priority, category, assignment, and resolution notes (Staff only).
   *
   * @tags Support
   * @name UpdateCase
   * @summary Update Case
   * @request PUT:/api/support/cases/{case_id}
   * @secure
   */
  updateCase = (caseId, data, params = {}) =>
    this.http.request({
      path: `/api/support/cases/${caseId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Quick status transition endpoint (Staff only).
   *
   * @tags Support
   * @name UpdateCaseStatus
   * @summary Update Case Status
   * @request PATCH:/api/support/cases/{case_id}/status
   * @secure
   */
  updateCaseStatus = (caseId, data, params = {}) =>
    this.http.request({
      path: `/api/support/cases/${caseId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Quick case assignment endpoint (Staff only).
   *
   * @tags Support
   * @name AssignCase
   * @summary Assign Case
   * @request PATCH:/api/support/cases/{case_id}/assign
   * @secure
   */
  assignCase = (caseId, data, params = {}) =>
    this.http.request({
      path: `/api/support/cases/${caseId}/assign`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Add a customer reply or staff internal note to the case thread.
   *
   * @tags Support
   * @name AddMessage
   * @summary Add Message
   * @request POST:/api/support/cases/{case_id}/messages
   * @secure
   */
  addMessage = (caseId, data, params = {}) =>
    this.http.request({
      path: `/api/support/cases/${caseId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List messages in the case thread (internal notes hidden from non-staff).
   *
   * @tags Support
   * @name ListMessages
   * @summary List Messages
   * @request GET:/api/support/cases/{case_id}/messages
   * @secure
   */
  listMessages = (caseId, params = {}) =>
    this.http.request({
      path: `/api/support/cases/${caseId}/messages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a support inquiry directly to Homy OS platform administrators.
   *
   * @tags Support
   * @name SubmitPlatformTicket
   * @summary Submit an inquiry to the Homy OS platform
   * @request POST:/api/support/platform-tickets
   * @secure
   */
  submitPlatformTicket = (data, params = {}) =>
    this.http.request({
      path: `/api/support/platform-tickets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List platform support tickets submitted by the authenticated user.
   *
   * @tags Support
   * @name ListSubmitterPlatformTickets
   * @summary List submitter's platform inquiries
   * @request GET:/api/support/platform-tickets
   * @secure
   */
  listSubmitterPlatformTickets = (query, params = {}) =>
    this.http.request({
      path: `/api/support/platform-tickets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description View details of a submitted platform ticket. Internal notes are redacted.
   *
   * @tags Support
   * @name GetSubmitterPlatformTicket
   * @summary View submitter's platform inquiry thread
   * @request GET:/api/support/platform-tickets/{ticket_id}
   * @secure
   */
  getSubmitterPlatformTicket = (ticketId, params = {}) =>
    this.http.request({
      path: `/api/support/platform-tickets/${ticketId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Post an inbound customer reply to the platform ticket thread.
   *
   * @tags Support
   * @name AddSubmitterPlatformMessage
   * @summary Post a reply to a submitted platform inquiry
   * @request POST:/api/support/platform-tickets/{ticket_id}/messages
   * @secure
   */
  addSubmitterPlatformMessage = (ticketId, data, params = {}) =>
    this.http.request({
      path: `/api/support/platform-tickets/${ticketId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List support tickets (legacy alias returning list).
   *
   * @tags Support
   * @name ListTickets
   * @summary List Tickets
   * @request GET:/api/support/tickets
   * @deprecated
   * @secure
   */
  listTickets = (params = {}) =>
    this.http.request({
      path: `/api/support/tickets`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a support ticket (legacy alias).
   *
   * @tags Support
   * @name CreateTicket
   * @summary Create Ticket
   * @request POST:/api/support/tickets
   * @deprecated
   * @secure
   */
  createTicket = (data, params = {}) =>
    this.http.request({
      path: `/api/support/tickets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a support ticket (legacy alias).
   *
   * @tags Support
   * @name GetTicket
   * @summary Get Ticket
   * @request GET:/api/support/tickets/{ticket_id}
   * @deprecated
   * @secure
   */
  getTicket = (ticketId, params = {}) =>
    this.http.request({
      path: `/api/support/tickets/${ticketId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a support ticket (legacy alias).
   *
   * @tags Support
   * @name UpdateTicket
   * @summary Update Ticket
   * @request PUT:/api/support/tickets/{ticket_id}
   * @deprecated
   * @secure
   */
  updateTicket = (ticketId, data, params = {}) =>
    this.http.request({
      path: `/api/support/tickets/${ticketId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Add a message to a support ticket (legacy alias).
   *
   * @tags Support
   * @name AddMessage2
   * @summary Add Message
   * @request POST:/api/support/tickets/{ticket_id}/messages
   * @deprecated
   * @originalName addMessage
   * @duplicate
   * @secure
   */
  addMessage2 = (ticketId, data, params = {}) =>
    this.http.request({
      path: `/api/support/tickets/${ticketId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List ticket messages (legacy alias).
   *
   * @tags Support
   * @name ListMessages2
   * @summary List Messages
   * @request GET:/api/support/tickets/{ticket_id}/messages
   * @deprecated
   * @originalName listMessages
   * @duplicate
   * @secure
   */
  listMessages2 = (ticketId, params = {}) =>
    this.http.request({
      path: `/api/support/tickets/${ticketId}/messages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
